import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Tab } from "@pentabd/ui";

import AssetsListTable from "../Assets";
import GeneralInfo from "../GeneralInfo";

import { EmployeePropType } from "@type/inventory/employee";

export const Employee = ({
  id,
  isProfile,
  isProfileDisabled,
}: EmployeePropType) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<number>(0);

  const tabData = [
    {
      label: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.TABS.GENERAL_INFO"),
      component: <GeneralInfo id={id} isProfile={isProfile} />,
    },
    {
      label: t("INVENTORY_EMPLOYEE.EMPLOYEE_DETAILS.TABS.ASSETS"),
      component: (
        <AssetsListTable
          id={id}
          isProfile={isProfile}
          isProfileDisabled={isProfileDisabled}
        />
      ),
    },
  ];

  return (
    <>
      <Tab active={activeTab} setActiveTab={setActiveTab}>
        <Tab.Heads>
          {tabData.map(({ label }, i) => (
            <Tab.Item key={i} index={i} label={label} />
          ))}
        </Tab.Heads>
        <Tab.ContentWrapper>
          {tabData.map(({ component }, i) => (
            <Tab.Content key={i} index={i}>
              {component}
            </Tab.Content>
          ))}
        </Tab.ContentWrapper>
      </Tab>
    </>
  );
};
